var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCardRec(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 0H0V2H2V0ZM4 0H6V2H4V0ZM10 0H8V2H10V0ZM12 0H14V2H12V0ZM16 0H18V2H16V0ZM0 4H2V6H0V4ZM2 8H0V10H2V8ZM0 12H2V14H0V12ZM2 16H0V18H2V16ZM4 16H6V18H4V16ZM10 16H8V18H10V16ZM16 8H18V10H16V8ZM18 4H16V6H18V4ZM12 14V12H18V14H16V16H14V18H12V14ZM16 16V18H18V16H16Z",
    fill: "url(#paint0_linear_498_38234)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_498_38234",
    x1: -1.17347e-7,
    y1: 2.25,
    x2: 18.0055,
    y2: 18.0414,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5C4E97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#383838"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardRec);
export default __webpack_public_path__ + "static/media/card-rec.026947ba282dfb618afc01310dd323f9.svg";
export { ForwardRef as ReactComponent };